export default __webpack_public_path__ + "static/media/10.5db9c07c.svg";